import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      mainTitle: {
        marginTop: '24px',
      },
      subhead: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 'bold',
        color: sicrediColors.secondarySicrediDarker,
        marginTop: theme.spacing(1),
      },
      clearIcon: {
        fontSize: 9,
      },
      searchIcon: {
        color: sicrediColors.primarySicrediDark,
      },
      statusPautas: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      },
      statusPautasIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
        height: 40,
        borderRadius: '50%',
        marginRight: theme.spacing(2),
      },
      pautas: {
        marginBottom: '20px',
      },
      adviceColaborador: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        '& > svg': {
          width: 32,
          height: 32,
          marginRight: theme.spacing(3),
          fill: sicrediColors.primarySicredi,
        },
        '& > p': {
          fontFamily: '"Nunito", sans-serif',
          fontSize: 16,
          fontWeight: 400,
          lineHeight: '24px',
          textAlign: 'justify',
        },
      },
      adviceColaboradorConfirm: {
        display: 'flex',
        width: '100%',
        margin: theme.spacing(3, 0),
        justifyContent: 'flex-end',
      },
    }),
  { name: 'EfetivacaoVotacao' }
);
